/* eslint-disable */
import { Component, Fragment } from 'react';
import { cancelSubscription } from './query';
import Loading from '../../components/Loading';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import Message from '../Message';
import { CHECKBOX_ITEMS } from './config';

class UserCancelation extends Component {
    constructor() {
        super();

        this.onChangeTextarea = this.onChangeTextarea.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.isDisabledButton = this.isDisabledButton.bind(this);
        this.slectAll = this.slectAll.bind(this);

        this.state = {
            feedback: [],
            textareaValue: '',
            isLoading: false,
            isOpenModal: false,
        };
    }

    onCheck(e) {
        const value = e.target.value;
        if (this.state.feedback.includes(value)) {
            this.setState({
                feedback: this.state.feedback.filter((item) => item !== value),
                allSelect: false,
            });
        } else {
            const newItems = [...this.state.feedback, value];
            this.setState({
                feedback: newItems,
                allSelect: newItems.length === CHECKBOX_ITEMS.length,
            });
        }
    }

    onChangeTextarea(e) {
        this.setState({
            textareaValue: e.target.value,
        });
    }

    slectAll() {
        if (this.state.allSelect) {
            this.setState({
                feedback: [],
                allSelect: false,
            });
        } else {
            this.setState({
                feedback: CHECKBOX_ITEMS,
                allSelect: true,
            });
        }
    }

    async onSubmit() {
        try {
            this.setState({
                isLoading: true,
                isOpenModal: false,
            });
            const data = {
                reason: this.state.feedback.join(','),
                comment: this.state.textareaValue,
            };
            const response = await cancelSubscription(data, this.props.license_id);
            const resData = await response.json();
            if (response.status === 400) {
                this.setState({
                    isLoading: false,
                    message: resData?.message,
                    message_tag: 'error',
                });
            } else if (response.status === 200) {
                this.setState({
                    message: resData?.message,
                    message_tag: 'success',
                });
                window.location.href = '/settings';
            }
        } catch (err) {
            console.log('error', err);
            this.setState({
                isLoading: false,
                message: 'Something went erong',
                message_tag: 'error',
            });
        }
    }
    onCloseModal() {
        this.setState({
            isOpenModal: false,
        });
    }
    onOpenModal() {
        this.setState({
            isOpenModal: true,
        });
    }

    deleteMessage() {
        this.setState({
            message: '',
            message_tag: '',
        });
    }

    isDisabledButton() {
        if (this.state.isLoading) return true;
        if (this.state.feedback.includes(CHECKBOX_ITEMS[8]) && !this.state.textareaValue)
            return true;
        if (!this.state.textareaValue && this.state.feedback?.length === 0) return true;
        return false;
    }

    render() {
        return (
            <>
                <div className="card table-main rounded-main overflow-hidden user-cancelation-container">
                    <div className="card-header">
                        <p className="card-title">Cancel Gddash</p>
                    </div>
                    <div className="card-body d-flex justify-content-center">
                        <div className="user-cancelation-container-body">
                            <div className="customers-selects-header">
                                Mind telling us why you're cancelling? Check all that apply.
                            </div>
                            <div className="customers-selects">
                                <div className="customers-selects-item">
                                    <div className="d-flex align-items-center">
                                        <input
                                            id="domain-all"
                                            type="checkbox"
                                            onChange={this.slectAll}
                                            checked={this.state.allSelect}
                                        />
                                        <label htmlFor="domain-all">
                                            <span>Select All</span>
                                        </label>
                                    </div>
                                </div>
                                {CHECKBOX_ITEMS?.map((item, i) => (
                                    <Fragment key={item}>
                                        <div key={item} className="customers-selects-item">
                                            <div className="d-flex align-items-center">
                                                <input
                                                    id={`domain-${i}`}
                                                    type="checkbox"
                                                    checked={this.state.feedback.includes(item)}
                                                    onChange={this.onCheck}
                                                    value={item}
                                                />
                                                <label htmlFor={`domain-${i}`}>
                                                    <span>{item}</span>{' '}
                                                </label>
                                            </div>
                                        </div>
                                        {i === CHECKBOX_ITEMS.length - 1 &&
                                            this.state.feedback.includes(item) && (
                                                <div className="customers-selects-item user-cancelation-container-item additiona-feedback additional-field">
                                                    <label className="d-block">
                                                        Additional Feedback (Optional):
                                                        <div className="additional-field-description">
                                                            We value your feedback. Is there
                                                            anything else you'd like to share about
                                                            your experience?
                                                        </div>
                                                    </label>
                                                    <div>
                                                        <textarea
                                                            placeholder="Let us know you really feel"
                                                            rows="4"
                                                            cols="40"
                                                            onChange={this.onChangeTextarea}
                                                            value={this.state.textareaValue}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            )}
                                    </Fragment>
                                ))}
                            </div>
                            <div className="user-cancelation-container-description">
                                You will continue to have access to your paid features until the end
                                of your current billing period on {this.props.end_date}.
                            </div>
                            <div className="user-cancelation-container-btn">
                                <a href="/settings">Cancel</a>
                                <button
                                    onClick={this.onOpenModal}
                                    disabled={this.isDisabledButton()}
                                >
                                    {!this.state.isLoading ? (
                                        'Cancel subscription'
                                    ) : (
                                        <div className="user-cancelation-container-loading">
                                            <Loading onlyPreloader />
                                        </div>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <ConfirmationModal
                    isOpen={this.state.isOpenModal}
                    onClose={this.onCloseModal}
                    message={`You will continue to have access to your paid features until the end of your current billing period on ${this.props.end_date}.`}
                    buttonName="Cancel subscription"
                    onSubmit={this.onSubmit}
                />
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tag}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
            </>
        );
    }
}
export default UserCancelation;
